'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicMetaData = undefined;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _noAuthApiClient = require('hub-http/clients/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Quick fetched, check publicEarlyRequester.js
var getPublicMetaData = exports.getPublicMetaData = function getPublicMetaData() {
  var countryOverride = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var earlyRequest = window.quickFetch && window.quickFetch.getRequestStateByName('public-meta');

  if (earlyRequest) {
    return new _q2.default.Promise(function (resolve, reject) {
      earlyRequest.whenFinished(function (result) {
        resolve(result);
        window.quickFetch.removeEarlyRequest('purchase-motions');
      });
      earlyRequest.onError(function (err) {
        reject(err);
        window.quickFetch.removeEarlyRequest('purchase-motions');
      });
    });
  } else {
    // This logic and code should be kept consistent with publicEarlyRequester.js
    var navigator = window.navigator;
    var preferredLanguage = navigator.languages || navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage;

    var publicMetaUrl = '/api-passthrough/eligibility-engine/v2/public';

    if (preferredLanguage && preferredLanguage.length) {
      if (Array.isArray(preferredLanguage)) {
        // This is simpler than the existing dot com logic
        // but I think this is sufficient since the fallbacks
        // aren't very important
        // See: https://codepen.io/anythingcodes/pen/XwdzYW?editors=0010
        preferredLanguage = preferredLanguage[0];
      }

      publicMetaUrl = publicMetaUrl + '/' + preferredLanguage.toLowerCase();
    }

    var isInIndia = window.location.host.indexOf('hubspot.in') > -1;

    var preferredCountryFromDomain = isInIndia ? 'in' : window.COUNTRY_CODE_FROM_LOCALE;

    var preferredCountry = countryOverride || preferredCountryFromDomain;

    if (preferredCountry) {
      publicMetaUrl = publicMetaUrl + '?preferredCountry=' + preferredCountry;
    }

    return _noAuthApiClient2.default.get(publicMetaUrl);
  }
};


//////////////////
// WEBPACK FOOTER
// ./js/api/public-only/PublicMetaDataApi.js
// module id = 790
// module chunks = 3 4